// Components==============
import ReflectionItem from 'pages/Growth/Reflect/components/ReflectionItem/ReflectionItem';
import './Views.module.scss';
import React, { useContext } from 'react';
import GridFiller from 'components/UI/GridFiller/GridFiller';
import { useRedux } from 'hooks/useRedux';
import { ReflectContext } from '../Reflect';
// =========================

export default function PeerReflectionView() {
  const { peerId, wrapperRef } = useContext(ReflectContext);

  const peerReflectionActivity = useRedux((state) =>
    peerId
      ? state.reflection?.entities.byId?.[parseInt(peerId)].projectProcess
        ? state.reflection?.entities.byId?.[parseInt(peerId)].projectProcess
        : state.reflection?.entities.byId?.[parseInt(peerId)].project_process
      : undefined
  );

  return (
    <div styleName="wrapper" ref={wrapperRef}>
      {!!peerReflectionActivity && (
        <ReflectionItem activity={peerReflectionActivity} />
      )}
      <GridFiller />
    </div>
  );
}
